import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoDividerComponent } from './avano-divider.component';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoDividerComponent],
  declarations: [AvanoDividerComponent]
})
export class AvanoDividerModule {}
